import { AddressArgsInterface } from '../interface/args/address-args.interface';

export class Address {
  public number: string;
  public path: string;
  public city: string;
  public zipCode: string;
  public country: string;

  constructor(args?: AddressArgsInterface) {
    if (args && args.number) {
      this.number = args.number;
    }
    if (args && args.path) {
      this.path = args.path;
    }
    if (args && args.city) {
      this.city = args.city;
    }
    if (args && args.zipCode) {
      this.zipCode = args.zipCode;
    }
    if (args && args.country) {
      this.country = args.country;
    }
  }

  public toString(): string {
    let fullAddress = '';
    if (this.number) {
      fullAddress += `${this.number}, `;
    }
    if (this.path) {
      fullAddress += `${this.path}, `;
    }
    if (this.zipCode) {
      fullAddress += `${this.zipCode}${!this.city ? ', ' : ''}`;
    }
    if (this.city) {
      fullAddress += `${this.city} ,`;
    }
    if (this.country) {
      fullAddress += `${this.country}`;
    }
    return fullAddress;
  }

  public isValid(): boolean {
    return this.path !== undefined && this.city !== undefined;
  }
}
